
import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, redirect, Navigate } from "react-router-dom";
import "./App.css";
import LandingPage from "./Pages/LandingPage";

const App = () => {


  useEffect(() => {
  }, []);



  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />

      </Routes>
    </BrowserRouter>

  );
};

export default App;
